export default __webpack_public_path__ + "static/media/5-1820x480无糖茶.843bebc1.jpg";